import { ArrowLeftIcon } from "@phosphor-icons/react/dist/csr/ArrowLeft";
import { ArrowRightIcon } from "@phosphor-icons/react/dist/csr/ArrowRight";
import { Link } from "react-router-dom";
import { Stack } from "@volca/ui/components/ui/stack";
import { cn } from "@volca/ui/lib/utils";
import { getHelpTopicPath } from "./routes";
import { getHelpGuideNeighbors, type HelpTopic } from "./topics";

export const HelpGuideNavigation = ({
  topics,
  currentId,
}: {
  topics: HelpTopic[];
  currentId: string;
}) => {
  const { previous, next } = getHelpGuideNeighbors(topics, currentId);
  if (!previous && !next) return null;

  return (
    <nav
      aria-label="Guide navigation"
      className="mt-8 flex gap-6 border-t border-line pt-5"
    >
      {[
        { topic: previous, label: "Previous guide", Icon: ArrowLeftIcon },
        { topic: next, label: "Next guide", Icon: ArrowRightIcon },
      ].map(({ topic, label, Icon }) =>
        topic ? (
          <Link
            key={label}
            to={getHelpTopicPath(topic.id)}
            aria-label={`${label}: ${topic.title}`}
            className={cn(
              "flex min-w-0 flex-1 items-center gap-3 rounded-md py-2 text-link hover:underline focus-visible:ring-2 focus-visible:ring-focus focus-visible:outline-none",
              { "ml-auto flex-row-reverse text-right": label === "Next guide" },
            )}
          >
            <Icon className="h-4 w-4 shrink-0" aria-hidden="true" />
            <Stack gap={1} align="stretch">
              <span className="text-xs text-subtle">{label}</span>
              <span className="text-base font-medium text-link">
                {topic.title}
              </span>
            </Stack>
          </Link>
        ) : null,
      )}
    </nav>
  );
};
